<template>
  <div class="c-uploads-page">
    <DeactivatedEmptyState v-if="isDeactivated" title="Upload Media"></DeactivatedEmptyState>
    <h1 v-else>Upload Media</h1>
  </div>
</template>

<script>
import DeactivatedEmptyState from '@/components/deactivated-empty-state.vue';

export default {
	components: {
		DeactivatedEmptyState,
	},
	computed: {
		isDeactivated: function () {
			return this.$store.getters['users/isTrialOver'];
		},
	},
};
</script>

<style lang="scss">
.c-uploads-page {
  height: 100vh;
  position: relative;
  overflow-y: auto;
}
</style>
